import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import classNames from 'classnames';

const AdvanceTable = ({
  getTableProps,
  headers,
  page,
  prepareRow,
  headerClassName,
  bodyClassName,
  rowClassName,
  rowStyle,
  tableProps,
  filters,
  handleFilterChange,
  showFilterRow
}) => {
  return (
    <div className="projects-table-wrapper">
      <Table {...getTableProps(tableProps)}>
        <thead className={headerClassName}>
          <tr>
            {headers.map((column, index) => (
              <th
                key={index}
                {...column.getHeaderProps(
                  column.getSortByToggleProps(column.headerProps)
                )}
              >
                {column.render('Header')}
                {column.canSort ? (
                  column.isSorted ? (
                    column.isSortedDesc ? (
                      <span className="sort desc" />
                    ) : (
                      <span className="sort asc" />
                    )
                  ) : (
                    <span className="sort" />
                  )
                ) : (
                  ''
                )}
              </th>
            ))}
          </tr>
          {showFilterRow && (
            <tr>
              {headers.map((column, index) => (
                <th key={index}>
                  {column.render('Header') !== 'S No:' && (
                    <input
                      type="text"
                      placeholder={`Search`}
                      value={filters[column.id] || ''}
                      onChange={e =>
                        handleFilterChange(column.id, e.target.value)
                      }
                      style={{ width: 120 }}
                    />
                  )}
                </th>
              ))}
            </tr>
          )}
        </thead>
        <tbody className={bodyClassName}>
          {page.map((row, i) => {
            prepareRow(row);

            // Handle rowClassName as either string or function
            let rowClass = rowClassName;
            if (typeof rowClassName === 'function') {
              rowClass = rowClassName(row);
            }

            // Handle rowStyle as function
            let style = {};
            if (typeof rowStyle === 'function') {
              style = rowStyle(row) || {};
            }

            return (
              <tr
                key={i}
                className={classNames(rowClass, {
                  'react-table-sub-row': row.depth !== 0
                })}
                style={style}
                {...row.getRowProps()}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={classNames({
                        'react-table-sub-row-item': row.depth !== 0
                      })}
                      {...cell.getCellProps(cell.column.cellProps)}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

AdvanceTable.propTypes = {
  getTableProps: PropTypes.func,
  headers: PropTypes.array,
  page: PropTypes.array,
  prepareRow: PropTypes.func,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  rowStyle: PropTypes.func,
  tableProps: PropTypes.object,
  filters: PropTypes.object,
  handleFilterChange: PropTypes.func,
  showFilterRow: PropTypes.bool
};

export default AdvanceTable;
